<script setup lang="ts">
import { BtnOutlined } from '~/components/ui/Buttons'
import GroovizAmount from '~/components/ui/GroovizAmount.vue'

import type { Influencer, StatsV3Influencer } from '~/types/influencer'

type Props = {
  isContest?: boolean
  influencer: Influencer | StatsV3Influencer
  isSelected: boolean
  isAway: boolean
  selectedLabel?: string
}

const props = withDefaults(defineProps<Props>(), {
  isContest: false,
  selectedLabel: '',
})

const { t } = useI18n()
const { toggleInf } = useCartToggleInfluencer()

const status = computed<'selected' | 'away' | ''>(() => {
  if (props.isSelected) return 'selected'
  else if (props.isAway) return 'away'
  else return ''
})
const text = computed(() => {
  if (props.isAway) {
    return t('influencer.card.footer01')
  } else {
    if (props.isSelected) {
      return props.selectedLabel
        ? props.selectedLabel
        : t('influencer.card.footer02')
    }

    return props.isContest
      ? t('influencer.card.footer.cta.contest')
      : t('influencer.card.footer00')
  }
})
const textFree = computed(() => {
  if (props.isSelected) return t('influencer.card.footer02')

  return props.isContest
    ? t('influencer.card.footer.cta.freeContest')
    : t('influencer.card.footer.cta.freeRegular')
})

function toggleSelect() {
  toggleInf(props.influencer)
}
</script>

<template>
  <BtnOutlined
    :disabled="isAway"
    small
    :class="{ '!tw-border-0': isSelected }"
    @click.stop="toggleSelect"
  >
    <div
      v-if="Number(influencer.cost) > 0"
      class="tw-mx-auto tw-flex tw-w-fit tw-flex-nowrap"
    >
      <span
        class="text"
        :class="{ [status]: true, 'tw-mr-1': !selectedLabel }"
        >{{ text }}</span
      >
      <i v-if="isSelected && !selectedLabel" class="fas fa-check tw-ml-1" />
      <GroovizAmount
        v-else-if="!isSelected && !isAway"
        class="text groovizIcon"
        :amount="influencer.cost"
      />
    </div>
    <div v-else class="tw-flex tw-flex-nowrap">
      <span
        class="text"
        :class="{ [status]: true, 'tw-mr-1': !selectedLabel }"
        >{{ textFree }}</span
      >
      <i v-if="isSelected && !selectedLabel" class="fas fa-check tw-ml-1" />
    </div>
  </BtnOutlined>
</template>

<style scoped>
.text {
  color: var(--color-main);
  font-size: var(--font-size-small);
  font-weight: 500;
  display: inline-flex;
}

.text.groovizIcon :deep(.icon-grooviz) {
  font-size: 14px;
}
</style>
